.laws {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  background-color: var(--pgm-sys-color-surface);
  border-radius: 16px;
  box-shadow: var(--pgm-sys-elevation-level1);
  box-sizing: border-box;
}

.trigger {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  gap: var(--pgm-sys-spacing-20);
  padding: var(--pgm-sys-spacing-6);
  text-align: left;
  width: 100%;
}

.itemTexts {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.trigger:hover {
  background-color: var(--pgm-sys-color-surface-container-low);
}

.trigger:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: -3px;
}

.itemTitle {
  color: var(--pgm-sys-color-secondary);
}

.count {
  color: var(--pgm-sys-color-on-surface);
}

.chevron {
  color: var(--pgm-sys-color-on-surface-variant);
  flex-shrink: 0;
}

.chevron {
  font-size: 24px;
  line-height: 24px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  padding: 0 var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6);
}

.syllabus {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.amendments {
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  margin: 0;
  padding-left: var(--pgm-sys-spacing-6);
}

@media (max-width: 599.98px) {
  .trigger {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: var(--pgm-sys-spacing-2);
    padding: var(--pgm-sys-spacing-4);
  }

  .content {
    padding: 0 var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-4);
  }
}
